import { useMemo } from 'react';
import { useAsync } from 'react-async-hook';
import LoadingIndicatorFull from '../react/components/LoadingIndicatorFull';
import { withInjector } from '../react/hoc/withInjector';
import AngularRouteRenderer from './AngularRouteRenderer';
import RouteError from './RouteError';

const AngularRouteFetcher = ({ $injector, match: originalMatch, stateGetter }) => {
    const { result, error } = useAsync(
        () => stateGetter().then(module => [module.default, originalMatch]),
        [originalMatch, stateGetter]
    );
    const [loadedState, match] = result ?? [];

    const state = useMemo(() => {
        if (!loadedState) {
            return null;
        }
        $injector.loadNewModules(loadedState.modules);
        return { ...loadedState.state, url: match?.path };
    }, [loadedState, $injector, match?.path]);

    if (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return <RouteError />;
    }

    if (state) {
        return <AngularRouteRenderer match={match} state={state} $injector={$injector} />;
    }

    return <LoadingIndicatorFull />;
};

export default withInjector(AngularRouteFetcher);
